export const MENUITEMS = [
  {
    menutitle: "Workspace",
    menucontent: "Social Presence",
    Items: [
      { path: "/dashboard", icon: "home", title: "Dashboard", type: "link", permission: "dashboard.view" },
      { path: "/leads", icon: "user", title: "Leads", type: "link", permission: "leads.view" },
      { path: "/planning", icon: "calendar", title: "Planning", type: "link", permission: "planning.view" },
      { path: "/analytics", icon: "charts", title: "Analytics", type: "link", permission: "analytics.view" },
      { path: "/reviews", icon: "star", title: "Reviews", type: "link", permission: "reviews.view" },
      { path: "/reporting", icon: "file", title: "Reporting", type: "link", permission: "reports.view" },
      { path: "/inbox", icon: "email", title: "Inbox", type: "link", permission: "inbox.view" },
      { path: "/business-impact", icon: "project", title: "Business Impact", type: "link", permission: "impact.view" },
      { path: "/online-presence", icon: "social", title: "Online Presence", type: "link", permission: "presence.view" },
      { path: "/guidance", icon: "knowledgebase", title: "Guidance & Updates", type: "link", permission: "guidance.view" },
      { path: "/settings", icon: "settings", title: "Settings", type: "link", permission: "settings.view" },
    ],
  },
];
